import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Footer } from "../footer/footer";
import Projects from "../projects/projects";
import { WorkTimeLine } from "./workTimeline";

export const Work = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Retrieve the scroll position from sessionStorage
    const scrollPosition = sessionStorage.getItem("scrollPosition");
    if (scrollPosition) {
      // Scroll to the target div
      window.scrollTo({
        top: parseInt(scrollPosition, 10),
        behavior: "smooth",
      });

      // Clear the scroll position after use
      sessionStorage.removeItem("scrollPosition");
    }
  }, []);

  const goToHome = () => {
    sessionStorage.removeItem("scrollPosition");
    navigate("/");
  };

  const goToAbout = () => {
    sessionStorage.removeItem("scrollPosition");
    navigate("/about");
  };

  return (
    <div className="flex flex-col w-full h-full px-4 py-10 font-rubik overflow-scroll no-scrollbar max-w-7xl mx-auto md:px-16 lg:px-32">
      <div className="flex flex-col w-full">
        <div className="flex justify-between items-center">
          <div
            className="text-blue text-lg sm:text-xl md:text-2xl font-medium cursor-pointer"
            onClick={goToHome}
          >
            Vishal
          </div>
          <div
            className="bg-gradient-to-tr from-peach to-peachLite text-transparent bg-clip-text text-base sm:text-lg md:text-xl font-medium cursor-pointer"
            onClick={goToAbout}
          >
            About
          </div>
        </div>
      </div>
      {/* Work */}
      <WorkTimeLine />
      {/* Projects */}
      <div id="targetDiv" className="flex flex-col w-full h-full mt-10">
        <Projects />
      </div>
      <div className="flex flex-row items-center justify-center w-full text-lg text-blue gap-4 mt-10">
        <Footer />
      </div>
    </div>
  );
};
